export const ExportsInPublish = {
  flow: 'y',
  gap: 'A',
  margin: '- -Z2',
  childExtends: 'DomainItem',
  childrenAs: 'state',
  childProps: {
    align: 'start',
    Icon: {
      name: '{{ icon }}'
    },
    Hgroup: {
      H: {
        text: (el, s) => el.call('polyglot', s.title || '')
      },
      P: {
        text: (el, s) => el.call('polyglot', s.descr || '')
      }
    },
    Upgrade: {
      if: (el) => el.isFree()
    },
    Select: {
      padding: 'X Y2',
      margin: '-W Y2 - auto',
      background: 'none',
      color: 'currentColor',
      onChange: (ev, el, s, ctx) => {
        const value = ev.target.value
        if (value) {
          s.update({
            action: value
          })
        }
      },
      childrenAs: 'props',
      childProps: {
        tag: 'option',
        attr: {
          selected: (el, s) => el.node.value === s.action
        }
      },
      if: (el) => !el.isFree(),
      children: [
        {
          text: 'CLI'
        },
        {
          text: 'Zip'
        }
      ]
    },
    IconButton: {
      if: (el) => !el.isFree(),
      extends: ['CanvasButton', 'Button'],
      padding: 'Y2',
      margin: '-Y -Y2',
      icon: 'downloadOutline',
      aria: { label: (el) => el.call('polyglot', 'publish.exports.download') },
      gap: 'Y1',
      Icon: {
        order: 2,
        color: 'blue'
      }
    }
  },
  children: [
    {
      icon: 'terminal',
      title: 'publish.exports.local.title',
      descr: 'publish.exports.local.descr'
    },
    {
      icon: 'html',
      title: 'HTML',
      descr: 'publish.exports.html.descr'
    },
    {
      icon: 'jquery',
      title: 'jQuery',
      descr: 'publish.exports.jquery.descr'
    },
    {
      icon: 'react',
      title: 'React',
      descr: 'publish.exports.react.descr'
    },
    {
      icon: 'sf assets',
      title: 'Webp',
      descr: 'publish.exports.webp.descr'
    },
    {
      icon: 'icons',
      title: 'SVG',
      descr: 'publish.exports.svg.descr'
    }
  ]
}
